import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import BaseAccordion from '~/components/BaseAccordion.vue'

export default <RegisteredComponent>{
  name: 'Base Accordion Comp',
  tag: 'base-accordion-comp',
  type: 'vue',
  component: markRaw(BaseAccordion),
  inputs: [
    {
      name: 'items',
      friendlyName: 'List of items to show (bound data)',
      helperText:
        'This is the list of items. Make sure to bind it through Visual Editor',
      type: 'list',
      defaultValue: [
        {
          title: 'What is Lorem Ipsum?',
          content:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
      ],
      subFields: [
        { name: 'title', type: 'string' },
        { name: 'content', type: 'string' },
      ],
    },
    {
      name: 'allowExpandMultiple',
      friendlyName: 'Allow to expand more than one at a time',
      helperText:
        'If disabled only one item will be expanded at a time. Default: false',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'initialOpenedItems',
      friendlyName: 'Comma delimited list initial open items',
      helperText:
        'A comma separated list of items to be open initially. List starts counting from 0 up - e.g. 0 - first item, 1 - second item...',
      type: 'string',
      defaultValue: '0',
    },
  ],
}
